<template>
    <!-- 公告通知-->
    <div> 
        <div class="noticeTitle" v-for="(item,index)  in noticeList" :title="item.noticeTitle" :name="index" :key="index" @click="seeMore(index)">   
            <el-tag type="success" v-if="item.noticeType == 1">通知</el-tag>
            <el-tag type="danger"  v-if="item.noticeType == 2">公告</el-tag>
            <el-span>{{item.noticeTitle | ellipsis}}</el-span>
            <el-tag type="warning">{{item.createTime | formatTime}}</el-tag>
            <!-- <el-tag type="info" v-if="item.remark">{{item.remark}}</el-tag>           -->
        </div>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        ></el-pagination>
        <el-dialog title="详情" :visible.sync="moreOpen" width="780px" append-to-body>
            <div v-html="this.moreText" style="font-size: 16px;" ></div>
        </el-dialog>
    </div>  
</template>
<script>
    import {listNotice} from "@/api/notice";
    import {formatDate} from '@/utils/date';
    export default {
        name: "noticeBar",
        data() {
            return {
                noticeList:[],
                moreText: '',
                moreOpen: false,
                total: 0,
                // 查询参数
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                },
            };
        },
        
        methods: {
            openInfo(){
                this.open = true;
                this.getList();
            },
             //分页切换每页条数函数
            handleSizeChange(val) {
                this.queryParams.pageNum = 1;
                this.queryParams.pageSize = val;
                this.getList();
            },
            //当前页改变函数
            handleCurrentChange(val) {
                this.queryParams.pageNum = val;
                this.getList();
            },
            //获取公告信息
            getList() {
                listNotice(this.queryParams).then((response) => {
                    this.noticeList = response.data.list;
                    this.total = response.data.total;
                    this.data = response.data.list[0];
                });
            },
            seeMore(v){
               this.moreText = this.noticeList[v].noticeContent;
               this.moreOpen = true;
            }
        },
        created(){
            this.getList();
        },
        filters:{
            ellipsis(value){
                if (!value) return '';
                if (value.length > 40) {
                    return value.slice(0,40) + '...'
                }
                return value
            },
            formatTime(time) {
                if(time==null||time===''){
                return 'N/A';
                }
                let date = new Date(time);
                return formatDate(date, 'yyyy-MM-dd')
            },
        },     
    };
</script>
<style scoped>
  .noticeTitle {
    margin: 10px 10px;
    font-size: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/components/NoticeBar/notice.vue